import { WATER_NETWORK_FREEFORM_SEARCH_STEP } from '../../../utils/waterNetworkLayout';

export const getDuplicatedWidgetSize = ({
	rawWidth,
	rawHeight,
	minimumWidgetSize,
	isFreeformLayoutWidget,
	defaultDivWidth,
	defaultDivHeight,
	gap,
}) => {
	const normalizedWidth = Math.max(minimumWidgetSize.width, rawWidth);
	const normalizedHeight = Math.max(minimumWidgetSize.height, rawHeight);

	if (isFreeformLayoutWidget) {
		return {
			widgetWidth: normalizedWidth,
			widgetHeight: normalizedHeight,
		};
	}

	const colUnit = defaultDivWidth + gap;
	const rowUnit = defaultDivHeight + gap;
	const cols = Math.max(1, Math.round((normalizedWidth + gap) / Math.max(1, colUnit)));
	const rows = Math.max(1, Math.round((normalizedHeight + gap) / Math.max(1, rowUnit)));

	return {
		widgetWidth: (cols * defaultDivWidth) + (Math.max(0, cols - 1) * gap),
		widgetHeight: (rows * defaultDivHeight) + (Math.max(0, rows - 1) * gap),
	};
};

export const findNearestEmptySpotForMetrics = ({
	startLeft,
	startTop,
	widgetWidth,
	widgetHeight,
	widgetsToCheck = [],
	metrics,
	defaultDivWidth,
	defaultDivHeight,
	toPxNumber,
	checkOverlap,
	subjectWidget = null,
	searchStep = null,
}) => {
	if (!metrics) return { found: false, left: 0, top: 0 };

	const gap = metrics.gap || 0;
	const gridColumnSize = searchStep || defaultDivWidth + gap;
	const gridRowSize = searchStep || defaultDivHeight + gap;
	const ww = toPxNumber(widgetWidth, 0);
	const wh = toPxNumber(widgetHeight, 0);
	const minX = metrics.padLeft || 0;
	const maxX = Math.max(minX, (metrics.width || 0) - (metrics.padRight || 0) - ww);
	const minY = metrics.padTop || 0;
	const maxY = Math.max(minY, (metrics.height || 0) - (metrics.padBottom || 0) - wh);
	const usableWidth = metrics.usableWidth || 0;
	const usableHeight = metrics.usableHeight || 0;
	const sx = toPxNumber(startLeft, 0);
	const sy = toPxNumber(startTop, 0);
	const maxCols = Math.max(0, Math.floor((usableWidth - ww) / Math.max(1, gridColumnSize)) + 1);
	const maxRows = Math.max(0, Math.floor((usableHeight - wh) / Math.max(1, gridRowSize)) + 1);

	let bestX = null;
	let bestY = null;
	let minDist = Infinity;

	for (let r = 0; r < maxRows; r++) {
		for (let c = 0; c < maxCols; c++) {
			const x = minX + (c * gridColumnSize);
			const y = minY + (r * gridRowSize);

			if (x < minX || y < minY) continue;
			if (x > maxX || y > maxY) continue;
			if (checkOverlap(x, y, ww, wh, widgetsToCheck, null, subjectWidget)) continue;

			const d = (x - sx) * (x - sx) + (y - sy) * (y - sy);
			if (d < minDist) {
				minDist = d;
				bestX = x;
				bestY = y;
			}
		}
	}

	if (bestX === null) return { found: false, left: 0, top: 0 };
	return { found: true, left: bestX, top: bestY };
};

export const findNearestFreeformDuplicationSpot = (params) => (
	findNearestEmptySpotForMetrics({
		...params,
		searchStep: WATER_NETWORK_FREEFORM_SEARCH_STEP,
	})
);
